import React from 'react';
import PropTypes from 'prop-types';
import ImageBlock from '../ImageBlock';

export default class GenericNavList extends React.Component {

  constructor(props) {
    super(props);
    this.state = { visibleSubMenuId: "", mobShow:false };
  }
  static propTypes = {
    items: PropTypes.array,
    prefix: PropTypes.string,
    showDesc: PropTypes.bool,
  }

  static defaultProps = {
    prefix: 'menu',
    showDesc: true
  }
  toggleSubMenu = (event, subMenuId) => {
    event.preventDefault();
    this.setState({ visibleSubMenuId: subMenuId });
  }
  getInnerMenuWithDesc(item) {
    let str = window.location.href;
    let menuName = str.includes("/es/") ?item.label_es_mx:str.includes("/en-uk/") ?item.label_uk_mx:item.label_en;
    let desc = str.includes("/es/") ?item.desc_es_mx:str.includes("/en-uk/") ?item.desc_uk_mx:item.desc_en;
    return <>
      {window.innerWidth < 1050 &&
      <div>
        <div className="mega-menu-left">
          <h2 className="menu-title">{menuName}</h2>
          <p>{desc} {this.props.showDesc}</p>
        </div>
        <div className="mega-menu-right">
          <GenericNavList style={{'display':'flex'}} items={item.children} showDesc={this.props.showDesc}></GenericNavList>
          <button className="btn btn-circle nav-back-link" onClick={(e) => { this.toggleSubMenu(e, "") }}>
            <i className="icon icon-prev"></i>
          </button>
        </div>
      </div>
    }
    {window.innerWidth > 1049 &&
      <div style={{'padding':'0px 30px 0px 40px','width':'100%'}}>
        <h2 className="menu-title">{menuName}</h2>
        <p>{desc} {this.props.showDesc}</p>
          <GenericNavList style={{'display':'flex'}} items={item.children} showDesc={this.props.showDesc}></GenericNavList>
          <button className="btn btn-circle nav-back-link" onClick={(e) => { this.toggleSubMenu(e, "") }}>
            <i className="icon icon-prev"></i>
          </button>
      </div>
    } 
    </>;
  }
  getInnerMenuWithOutDesc(item) {
    return <GenericNavList items={item.children} showDesc={this.props.showDesc}></GenericNavList>;
  }
  getChildMenu(item) {
    if (item.children && item.children.length > 0) {
      let str = window.location.href;
      let menuName = str.includes("/es/") ?item.label_es_mx:str.includes("/en-uk/") ?item.label_uk_mx:item.label_en;
      let imgurl = []
      {item.children.map((submenu,i) => {
        imgurl.push(submenu.category_img.url)
        })
      }
      return (<div style={{'width':'100%'}} className={"sub-nav mega-menu" + (this.state.visibleSubMenuId == menuName.replace(/\s+/g, '') ? " open" : "")}> 
        {this.props.showDesc ? this.getInnerMenuWithDesc(item) : this.getInnerMenuWithOutDesc(item)}
      </div>);
  }
}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
  render() {
    return (
      <ul className={`${this.props.prefix}`}>
        {
          this.props.items.map((item, i) => {
            let current = RegExp(item.href, 'g').test(window.location.href);

            let str = window.location.href;
            let menuName = str.includes("/es/") ?item.label_es_mx:str.includes("/en-uk/") ? item.label_uk_mx:item.label_en;
            let url = str.includes("/es/") ?item.url_es_mx:str.includes("/en-uk/") ?item.url_uk_mx:item.href;
            let img = item.category_img;
            let footer = this.props.footer;
            return (
              <li
                data-active={item.active}
                key={i}
                className={`${current ? 'active' : ''}` + `${item.children.length > 0 ? ' has-menu' : footer}`}>
                  {item.category_img.url &&
                    <a href={url} > 
                    <img className="menu-imgs" style={{'margin':'auto', height:"100px",width:"100px"}} src={item.category_img.url} onClick ={url}/>
                    </a>
                  }
                <a
                  href={url} target={item.openInNewWindow ? '_blank' : ''}>
                  <div>{menuName}</div>
                  {item.children.length > 0 &&
                    <i className="nav-icon icon-arrow-right" onClick={(e) => { this.toggleSubMenu(e, menuName.replace(/\s+/g, '')) }}></i>
                  }
                </a>
                {this.getChildMenu(item)}

              </li>
            );
          })
        }
        {this.props.children}
      </ul>
    )
  }
}